import $ from "jquery";

jQuery(function () {
  // Google Translate ///////////////////////////////////
  // function closeTranslateMenu(e) {
  //   // console.log("e.key", e.key);

  //   if (e.key === "Escape") {
  //     $(".button-close-translate").trigger("click");
  //   }
  // }

  // $(".button-open-translate").on("click", function (e) {
  //   e.preventDefault();
  //   $(this).attr("aria-pressed", true);
  //   $(this).attr("aria-expanded", true);
  //   $(this).siblings(".translate-menu").show();

  //   document.addEventListener("keyup", closeTranslateMenu);
  // });

  // $(".button-close-translate").on("click", function () {
  //   $(".button-open-translate").attr("aria-pressed", false);
  //   $(".button-open-translate").attr("aria-expanded", false);
  //   $(this).parents(".translate-menu").hide();

  //   document.removeEventListener("keyup", closeTranslateMenu);
  // });

  // $(".translate-menu").on("keyup", function (e) {
  //   if (e.key === "Escape") {
  //     $(".translate-menu").hide();
  //   }
  // });


  $("#translate-container-desktop").append('<div id="google_translate_element"></div>');

  // Then move it based on viewport width
  function moveTranslateWidget() {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    if (vw > 1311) {
      $("#google_translate_element").appendTo("#translate-container-desktop");
    } else {
      $("#google_translate_element").appendTo("#translate-container-mobile");
    }
  }

  moveTranslateWidget();

  let resizeTimeout;
  $(window).on("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(moveTranslateWidget, 500);
  });


  // $(window).on("resize", function () {
  //   let myTimeout;

  //   const vw = Math.max(
  //     document.documentElement.clientWidth || 0,
  //     window.innerWidth || 0
  //   );

  //   clearTimeout(myTimeout);

  //   myTimeout = setTimeout(() => {
  //     if (vw > 1311) {
  //       $("#google_translate_element").appendTo("#translate-container-desktop");
  //     } else {
  //       $("#google_translate_element").appendTo("#translate-container-mobile");
  //     }
  //   }, 500);
  // });

  $(window).resize();
  // Google Translate END ///////////////////////////////////

  //---- Download File ----------------------------------------------------------------
  $(".downloadButton").on("click", function () {
    var docu_link = $(this).data("docu");
    // Extract the filename from the URL and decode it
    var fileName = decodeURIComponent(
      docu_link.substring(docu_link.lastIndexOf("/") + 1)
    );

    // Create a temporary link element
    var downloadLink = document.createElement("a");
    downloadLink.href = docu_link;

    // Set the download attribute with the decoded filename
    downloadLink.download = fileName;

    // Append the link to the document
    document.body.appendChild(downloadLink);

    // Trigger a click on the link to start the download
    downloadLink.click();

    // Remove the link from the document
    document.body.removeChild(downloadLink);
  });


  //INSPIRATIE DETAIL PAGE PADDING
  function adjustPadding() {
    var headerHeight = $('.inspiratiepunten-node-header .inspiratiepunten-basic-info').outerHeight();

    // console.log("orii", headerHeight);

    var subtractValue = 165; // default

    var screenWidth = $(window).width();

    if (screenWidth >= 1536) {
      subtractValue = 300;
    } else if (screenWidth >= 1312) {
      subtractValue = 280;
    } else if (screenWidth >= 1024) {
      subtractValue = 230;
    } else if (screenWidth >= 768) {
      subtractValue = 240;
    }

    var newHeight = headerHeight - subtractValue;
    // console.log("www", newHeight);

    if (screenWidth < 768) {
      const headerContainerHeight = $('#header-container').outerHeight();
      const baseHeaderHeight = $('.inspiratiepunten-node-header').outerHeight();

      newHeight = headerContainerHeight - baseHeaderHeight;
    }

    $('.content-after-header').css('padding-top', newHeight + 'px');
  }

  adjustPadding();

  $(window).on('resize', function () {
    adjustPadding();
  });

  //INSPIRATIE IMAGE BEHIND SHAPE SIZE
  function resizeTileShapes() {
    $('.iprt-thumbnail').each(function () {
      const container = $(this);
      const img = container.find('.iprt-thumbnail-img');
      const svg = container.find('.tile-shape-svg');

      const imgWidth = img.width();
      svg.attr('width', imgWidth);
      svg.attr('height', imgWidth);
    });
  }

  resizeTileShapes();

  $(window).on('resize', function () {
    resizeTileShapes();
  });


});
